import { put, all, retry } from 'redux-saga/effects';
import { reject, resolve } from '../api';
import * as types from '../constants';
import { authClient } from '../api/Client';
import { NOTIFICATION } from '../constants';
import {
  errorNotification,
  infoNotification,
  showNotification,
  successNotification,
  simpleErrorNotification,
} from '../../shared-components/Notifications';

export function* searchForTags({ queryString }) {
  try {
    let res;
    if (queryString?.trim()) {
      res = yield retry(4, 500, authClient?.Tags?.search, {
        name: queryString,
      });
    }

    yield put({
      type: resolve(types?.SEARCH_FOR_TAGS),
      payload: (res && res?.data()) || [],
      queryString,
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.SEARCH_FOR_TAGS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.SEARCH_FOR_TAGS)),
      }),
    ]);
  }
}

export function* addIOCTag({ tagName, ioc }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.createIOCTag, {
      uuid: ioc?.uuid,
      body: {
        tag: tagName?.tagName ? tagName?.tagName : tagName?.tag,
      },
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.ADD_IOC_TAG),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Tag successfully added.',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.ADD_IOC_TAG),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Adding Tag was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.ADD_IOC_TAG),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Tag successfully added.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.ADD_IOC_TAG),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.ADD_IOC_TAG)),
  //     }),
  //   ]);
  // }
}

export function* removeIOCTag({ tag, ioc }) {
  try {
    const res = yield retry(4, 500, authClient?.IOC?.deleteIOCTag, {
      tagUUID: tag,
      iocUUID: ioc,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.REMOVE_IOC_TAG),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Tag successfully removed.',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.REMOVE_IOC_TAG),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Removing Tag was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.REMOVE_IOC_TAG),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Tag successfully removed.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.REMOVE_IOC_TAG),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.REMOVE_IOC_TAG)),
  //     }),
  //   ]);
  // }
}

export function* deleteTag({ id, selectedProfile }) {
  try {
    // eslint-disable-next-line no-unused-vars
    const res = yield retry(4, 500, authClient.Tag.delete, {
      id: id,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_TAG),
        payload: { id, selectedProfile },
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Tag successfully removed.',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_TAG),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Removing Tag was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_TAG),
  //     payload: { id, selectedProfile },
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Tag successfully removed.',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_TAG),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.DELETE_TAG)),
  //     }),
  //   ]);
  // }
}
